import apiClient from '@/services/axios'

export async function get() {
  var response = await apiClient.get(process.env.VUE_APP_MARCOM_API_BASE_URL + '/admin/time-zones/country-codes');

  if (response) {
    console.log(response)
    return response.data;
  }

  throw new Error('Unable to get Country Codes.')
}
